import axios from 'axios/index'
import store from '../store'

export default () => {
  return axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    withCredentials: false,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'auth-token': store.getters.token
    }
  })
}
